<div *ngIf="parameters.isZonesOrZonesSystemControllerType()">
    <zones></zones>
</div>
<div *ngIf="!parameters.isZonesOrZonesSystemControllerType()">
    <tiles></tiles>
</div>
